import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {AnimationService, AnimationType} from '@core/services/animation.service';
import {VotingControlService} from '@modules/voting/voting-control.service';
import {PlayerService} from '@core/services/player.service';
import {SectionItem} from '@modules/voting/models/section-item';

@Component({
  selector: 'app-voting-item',
  templateUrl: './voting-item.component.html',
  styleUrls: ['./voting-item.component.scss']
})

export class VotingItemComponent {
  @Input() item: SectionItem;
  @Output() selectionToggle: EventEmitter<any> = new EventEmitter();
  @ViewChild('selectionStatus') selectionStatusElement;
  @ViewChild('rating') ratingElement;

  detailData = null;

  constructor(
    private animationService: AnimationService,
    private playerService: PlayerService,
    public votingControl: VotingControlService,
  ) { }

  toggleSelection(event?: Event) {
    if (event && this.ratingElement?.nativeElement.contains(event.target as Node)) {
      return; // ignore click if ratingElement was clicked
    }

    if (this.votingControl.submissionMode) {
      this.item.selected = !this.item.selected;
      this.animationService.animateElement(this.selectionStatusElement, this.item.selected ? AnimationType.POP : AnimationType.UN_POP);
      this.selectionToggle.emit(this.item.selected);
    }
  }

  get ratioSectionTotal() {
    return this.item.vote_count.ratio_section_total;
  }

  get ratioSectionMax() {
    return this.item.vote_count.ratio_section_max;
  }

  public async showItemDetails(event) {
    event.stopPropagation(); // prevent selection of item
    if (!this.detailData) {
      this.detailData = await this.playerService.fetchPlayerEventRating(this.votingControl.voting.origin.id, this.item.entityid);
    }
  }
}
